import React from 'react';
import { PropTypes } from 'prop-types';

export const preventEmptyStringInitialization = function (event, newValue, prevValue) {
  if (prevValue === null && newValue === '') {
    event.preventDefault();
  }
};

export const preventInvalidDateInitialization = function (event, newValue, prevValue) {
  if (newValue === 'Invalid date') {
    event.preventDefault();
  }
};

export const preventNullInitialization = function (event, newValue, prevValue) {
  if (prevValue === undefined && newValue === '') {
    event.preventDefault();
  }
};

// eslint-disable-next-line import/prefer-default-export
export const TextInput = ({
  input,
  meta: {
    touched,
    error,
    warning
  },
  required,
  hideHints,
  placeholder,
  type,
  className
}) => (
  <div>
    <input
      type={ type }
      { ...input }
      placeholder={ placeholder }
      className={ `${ className } ${ touched && error && 'is-error' }` }
      required={ required }
      autoComplete="off"
    />
    {
      !hideHints && touched && (
        (error && <p className="form-input-hint">{ error }</p>)
        || (warning && <p className="form-input-hint">{ warning }</p>)
      )
    }
  </div>
);

TextInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
    warning: PropTypes.any
  }).isRequired,
  required: PropTypes.bool,
  hideHints: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string
};

TextInput.defaultProps = {
  required: false,
  hideHints: false,
  placeholder: '',
  type: 'text',
  className: ''
};
